"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertArray;
function assertArray(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  if (!Array.isArray(value)) {
    throw new TypeError("".concat(label, " needs to be an array"));
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/utils/assertArray.js
// module id = 1878
// module chunks = 0